import React, { memo } from 'react';
import { Grid, Skeleton } from '@mui/material';

import ButtonsDivider from './ButtonsDivider';
import FlowWrapper from './FlowWrapper';

const FlowSkeleton = (): JSX.Element => (
  <FlowWrapper>
    <Grid container direction="row">
      <Grid item xs={12}>
        <Skeleton height={96} width="100%" />
      </Grid>
    </Grid>
    <ButtonsDivider />
    <Grid container direction="row" spacing={4}>
      <Grid item xs={12} sm={6}>
        <Skeleton height={96} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Skeleton height={96} width="100%" />
      </Grid>
    </Grid>
  </FlowWrapper>
);

export default memo(FlowSkeleton);
